import React from 'react'

export default function FAQ() {
  const faqs = [
    {
      question: "Boli li?",
      answer: "Ne. Većina klijenata smatra DEKA Again ugodnim zahvaljujući naprednom hlađenju."
    },
    {
      question: "Mogu li tretirati preplanulu kožu?",
      answer: "Da. DEKA tehnologija je sigurnija za veći broj tipova kože od starijih sustava."
    },
    {
      question: "Hoće li dlačice ponovno narasti?",
      answer: "Laser omogućuje dugotrajno smanjenje dlačica; s vremenom je moguć tek povremeni rast finijih dlačica."
    },
    {
      question: "Koliko traje jedan tretman?",
      answer: "Većina tretmana traje manje od 30 minuta."
    }
  ]

  return (
    <section className="py-20 px-6 md:px-12 lg:px-20 bg-white animate-on-scroll">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-light mb-12 text-[#2c3424] text-center">
          Često postavljana pitanja
        </h2>
        
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white p-8 rounded-lg">
              <h3 className="text-xl font-medium mb-3 text-[#2c3424]">
                {faq.question}
              </h3>
              <p className="text-[#1a1a1a] leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
        
        <p className="text-lg text-center mt-12 text-[#1a1a1a]">
          Personalizirane odgovore na vaša specifična pitanja dobit ćete tijekom besplatnih konzultacija.
        </p>
      </div>
    </section>
  )
}
